import { useState, useEffect } from "react";
import { loadSONumberList, loadSONumberListWarehouse } from "../services/storageLocationService";

const useGetSONumberList = (editID) => {

    const [salesOrderNumber, setSalesOrderNumber] = useState([]);
    const [selectedSalesOrderNumber, setSelectedSalesOrderNumber] = useState([]);
    const [selectedSalesOrderNumberID, setSelectedSalesOrderNumberID] = useState([]);
    const [isMaterialCodeDataLoaded, setIsMaterialCodeDataLoaded] = useState(false);
    const [ddloading, setddLoading] = useState(false);

    // Fetch sales order numbers
    const fetchRequestIndentNumber = async (selectedID) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plant_id: 1 };
        setddLoading(true); // Show loader

        try {

            let data;
            if (editID === 1) {
                const paraNew= { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, p_mode: 1 };
                data = await loadSONumberListWarehouse(paraNew);
            }
            else {
                data = await loadSONumberList(para);
            }

            if (data && data.length > 0) {
                setSalesOrderNumber(data);
                const initialDepartment = data.find((dept) => dept.so_number === selectedID);
                if (initialDepartment?.length > 0) {
                    setSelectedSalesOrderNumber(initialDepartment);
                    setIsMaterialCodeDataLoaded(true); // Update state after data is loaded
                }
            }
        } catch (error) {
            console.error("Error fetching sales order numbers:", error);
        }
        finally {
            setddLoading(false); // Hide loader after fetching
        }
    };

    // Load sales order numbers when the component mounts

    useEffect(() => {
        if (!isMaterialCodeDataLoaded && editID === 0) {
            fetchRequestIndentNumber();
        }
        else if (!isMaterialCodeDataLoaded && editID === 1) {
            fetchRequestIndentNumber();
        }
    }, [isMaterialCodeDataLoaded, editID]);

    // Function to update selected sales order number
    const loadSalesOrderNumberByID = (selectedID) => {
        setSelectedSalesOrderNumber(selectedID);
    };

    return {
        salesOrderNumber,
        selectedSalesOrderNumber,
        selectedSalesOrderNumberID,
        setSalesOrderNumber,
        setSelectedSalesOrderNumber,
        setSelectedSalesOrderNumberID,
        loadSalesOrderNumberByID,
        ddloading, setddLoading
    };

};

export default useGetSONumberList;
